import { useState } from 'react';
import { Link } from 'react-router-dom';
import "./index.css";
import serviceIcon3dPrint from '../../assets/images/service-icon-3dprint.webp'
import serviceIconApps from '../../assets/images/service-icon-apps.webp'
import serviceIconConsulting from '../../assets/images/service-icon-consulting.webp'
import serviceIconWebsite from '../../assets/images/service-icon-website.webp'
import serviceIconClients from '../../assets/images/service-icon-clients.png'

const offerings = [
  { title: "Custom 3D prints", icon: serviceIcon3dPrint, path: "/services/3dprints", linkLabel: "More Info" },
  { title: "Websites", icon: serviceIconWebsite, path: "/services/websites", linkLabel: "More Info" },
  { title: "App development", icon: serviceIconApps, path: "/services/appdev", linkLabel: "More Info" },
  { title: "Tech consulting", icon: serviceIconConsulting, path: "/services/consulting", linkLabel: "More Info" },
  { title: "Clients", icon: serviceIconClients, path: "/partners", linkLabel: "See our Clients and Partners" },
];

const About = () => {
  const [selectedOffering, setSelectedOffering] = useState<string | null>(null);

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="about-hero-copy">
          <h1>What we offer</h1>
          <div className="about-offerings" aria-label="What Hogcloud offers">
            {offerings.map((offering) => (
              <div
                className={`about-offering ${selectedOffering === offering.title ? 'active' : ''}`}
                key={offering.title}
              >
                <button
                  type="button"
                  className="about-offering-select"
                  onClick={() => setSelectedOffering(offering.title)}
                >
                  <img src={offering.icon} alt="" aria-hidden="true" />
                  <span className="about-offering-title">{offering.title}</span>
                </button>
                {selectedOffering === offering.title && (
                  <Link className="about-offering-link" to={offering.path}>
                    {offering.linkLabel}
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-contact-callout">
        <div className="about-contact-copy">
          <p className="about-kicker">Have an idea?</p>
          <h2>Tell us what you want to make or build.</h2>
          <p>
            Whether you need a custom print, a website, an app, or tech help,
            we would love to hear from you.
          </p>
          <a href="/contact" className="about-button">
            Contact Us
          </a>
        </div>
        <div className="about-story">
          <h1>A Family business</h1>
          <p>
           Are you a local business or creator looking to scale? We provide the modern tools necessary to run your business more efficiently and create memorable customer experiences. Our services are an investment in your success, typically paying for themselves through reduced labor costs and increased revenue.
          </p>

          <p>
            Our work is straightforward: listen to the idea, help shape it, and
            build something that fits.
          </p>

          <div className="legal-note">
            <p>
              Hogcloud, Inc. is a registered Arkansas S-Corporation located in Fayetteville,
              Arkansas. We are not affiliated with, endorsed by, or sponsored by the
              University of Arkansas, the Arkansas Razorbacks, or any of their associated
              organizations. We are simply proud members of the Fayetteville community.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;
